
import TabArticles from '../TabArticles';
import SeoUtil from '../SeoUtil';


const EntertainmentTab = () => {
  const tab_title = 'Zaujímavosti a zábava'
  const url_category = 'entertainment'

  return (<>
    <SeoUtil
      title={`Mudrosti Sveta | ${tab_title}`}
      description={tab_title}
      name='Mudrosti Sveta'
      type='articles' />
    <TabArticles tab_title={tab_title} url_category={url_category} />
  </>
  );
};

export default EntertainmentTab;